import { ProductEnumDTO } from 'features/shared/enums/dynamic/ProductEnumDTO';
import { BindCheckFieldFunction } from 'features/shared/forms/hooks/useForm';
import React from 'react';
import ProductBox from './ProductBox';
import { useTranslationWithPrefix } from 'features/shared/hooks/useTranslationWithPrefix';

type Props = {
  products: ProductEnumDTO[];
  bindCheckField: BindCheckFieldFunction;
}

const ProductListSubForm = ({ products, bindCheckField }: Props) => {
  //translations
  const tLabels = useTranslationWithPrefix("contracting\\contracting", "productListSubForm");

  // sub-renders
  const renderProducts = () => {
    return products.map((product) => (
      <div className="col-lg-6 px-2" key={product.code}>
        <ProductBox 
          product={product}
          bindCheckField={bindCheckField}
        />
      </div>
    ));
  };

  // return
  return (
    <>
      <h4 className="text-muted mb-3">{tLabels("title")}</h4>
      <div className="row no-gutters mx-n2">
        {renderProducts()}
      </div>
    </>
  )
}

export default ProductListSubForm;